import { useTranslation } from "../../core/translation.core";
import useShop, { useShopFull } from "../../hooks/useShop.hook";
import { Reward } from "../../types/reward";
import { format, addDays, addMonths } from "date-fns";

export default function RewardListRow({ reward }: { reward: Reward }) {
  const { selectedShop } = useShop();
  const {data: shop} = useShopFull();
  const { t, msg } = useTranslation();

  if (!selectedShop) return null;

  const shopRewardExpireDays = shop?.rewardExpireAfter;
  const months = Math.floor((shopRewardExpireDays ? shopRewardExpireDays : 400) / 30);


  const rewardExpireDate = reward.expirationDate
    ? format(new Date(reward.expirationDate), "yyyy-MM-dd HH:mm:ss")
    : reward.rewardDate
      ? format(addMonths(new Date(reward.rewardDate), months), "yyyy-MM-dd HH:mm:ss")
      : "N/A";
  const status = reward.points < 0 ? t(msg.reward.redeemed) : getStatus();

  return (
    <div className="grid grid-cols-[100px_auto] lg:grid-cols-6 gap-x-6 gap-y-3 px-6 py-6 border-t-[1px] text-sm">
      <div className="row-span-5 lg:row-span-2">{reward?.orderNumber}</div>
      <div>{reward.rewardDate ? format(new Date(reward.rewardDate), "yyyy-MM-dd HH:mm:ss") : 'N/A'}</div>
      <div>{rewardExpireDate}</div>
      <div>
        {reward.user?.firstName.toUpperCase() ?? 'N/A'} {reward.user?.lastName.toUpperCase() ?? 'N/a'}
      </div>

      <div>{status}</div>
      <div>{reward.points}</div>
    </div>
  );

  function getStatus() {
    switch (reward.status) {
      case "active":
        return t(msg.reward.active);
      case "expired":
        return t(msg.reward.expired);
      case "pending":
        return t(msg.order.pending);
      case "cancelled":
        return t(msg.order.cancelled);
      // case "redeemed":
      //   return t(msg.reward.redeemed);
    }
  }
}
